let updateCheckall = function() {
	if (this.statuslist.length == this.statusdata.length) {
		this.isCheckAll = true;
	} else {
		this.isCheckAll = false;
	}
};
export default updateCheckall;
